<template>
<div class="reveal bibreveal" id="contactoPopup" data-reveal>  
  <div class="centerContent">
    <p class="carouselTitle">{{ $t("UMA_LANG_SASUMA_HORARIO") }}</p>
    <span class="curso_linha3 azul_site_background"></span>
  </div>
  <div class="row">
    <div class="small-12 medium-12 large-12 columns horario_text">
      <b>Morada:</b><br>
      Rua de Santa Maria Nº253<br>
      9060-291 Funchal - Madeira<br>
      <br>
      <b>Contactos:</b><br>
      sasuma@sas.uma.pt<br>
      sasuma.info@sas.uma.pt<br>
      (+351) 291 201 810<br>
      <br>
      <b>Horário:</b><br>
      Das 09h00 às 12h30 e das 14h00 às 17h30<br>
      Atendimento Bolsas de Estudo: 09h00 às 12h00 e das 14h00 às 16h00<br>
    </div>
  </div>
  <button class="close-button horario" data-close aria-label="Close modal" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
</template>

<script>
import { onMounted, nextTick } from 'vue';

export default {
  setup () {
    
    onMounted(() => {
      nextTick(() => {
        const accord = $(".bibreveal");
        $(accord).foundation();
      })
    })

    return {}
  }
}
</script>

<style lang="scss" scoped>
#contactoPopup {
  width: 30%;
  max-width: 30%;
  top:109px !important;
}

.reveal-overlay{
  z-index: 999999999;
}

.reveal.bibreveal{
  width: 100%;
  max-width: 100%;
  padding: 50px;
}

.reveal.bibreveal .carouselTitle{
  padding-top: 0;
}

.reveal.bibreveal .curso_linha3{
  margin-bottom: 40px;
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.carouselTitle {
  font-family: 'Montserrat Bold';
  font-size: 30px;
  margin-top: 0px;
  color: #333333;
  display: inline-block;
  margin-bottom: 5px;
  padding-top: 85px;
}

.horario_text {
  font-family: "Montserrat";
  padding-top: 10px;
  margin-bottom: 20px;
}
</style>